export default __webpack_public_path__ + "static/media/hdp.927d0fd1.jpeg";